import type { LinkedInStartResponse, CallOfDutyStartResponse } from "../api/listener";

export const linkedInStart = async (): Promise<LinkedInStartResponse> =>
  Promise.resolve({ success: true, process_key: "process-key" });

export const callOfDutyStart = async (): Promise<CallOfDutyStartResponse> =>
  Promise.resolve({ success: true, process_key: "process-key" });
